import PropTypes from 'prop-types';
import { createContext } from 'react';
const DEFAULT_HEIGHT = 105;
const CanvasTopOffsetContext = /*#__PURE__*/createContext(DEFAULT_HEIGHT);
CanvasTopOffsetContext.Provider.propTypes = {
  value: PropTypes.number.isRequired
};
export const CanvasTopOffsetProvider = CanvasTopOffsetContext.Provider;
export default CanvasTopOffsetContext;